// extracted by mini-css-extract-plugin
export default {"title":"skills_title__blHNI","skill":"skills_skill__Okebc","bigBlock":"skills_bigBlock__7HWX9","text":"skills_text__-Dz6+","UI":"skills_UI__DXt1f"};